import {Svg} from "../../components/svg/components/Svg";
import {Path} from "../../components/svg/components/path";
import {SPORT_TYPES_ICON_DATA} from "./consts";
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../app/consts/colors";

export const SportTypeIcon = ({id, style, className, isActive, isHover}) => {
  const textPrimary: String = useThemeColor(COLORS.textPrimary);
  const textSecondary = useThemeColor(COLORS.textSecondary)
  const accentPrimary = useThemeColor(COLORS.accentPrimary)
  const svgProps = {
    style: {
      fill: isHover ? accentPrimary : (isActive ? textPrimary : textSecondary),
      ...style
    },
    className
  }

  return <Svg {...svgProps}>
    {
      SPORT_TYPES_ICON_DATA[id]?.map((d, index) => <Path d={d} key={index} fillRule={"evenodd"}/>)
    }
  </Svg>
};